<!-- 院校详情页 -->
<template>
  <div class='all'>
    <Top :hasShare="false"/>
    <!-- 顶部 -->
    <div class="top">
      <!-- logo -->
      <div class="logo">
        <div class="left">
          <van-image round
                     width="50px"
                     height="50px"
                     fit="cover"
                     :src="$global.imgUrl + orgInfo.coverImg" />
        </div>
        <div class="right">
          <div class="title">
            {{orgInfo.name}}
          </div>
        </div>
      </div>
      <!-- 外文名称 -->
      <div class="public-item">
        <div class="public-title">
          外文名称
        </div>
        <div class="public-text">
          {{orgInfo.englishName}}
        </div>
      </div>
      <!-- 简称 -->
      <div class="public-item">
        <div class="public-title">
          简称
        </div>
        <div class="public-text">
          {{orgInfo.abbreviation}}
        </div>
      </div>
      <!-- 创办时间 -->
      <div class="public-item">
        <div class="public-title">
          创办时间
        </div>
        <div class="public-text">
          {{orgInfo.establishTime}}
        </div>
      </div>
      <!-- 创办人 -->
      <div class="public-item">
        <div class="public-title">
          创办人
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.founder}}
        </div>
      </div>
      <!-- 办学性质 -->
      <div class="public-item">
        <div class="public-title">
          办学性质
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.category}}
        </div>
      </div>
      <!-- 学校类别 -->
      <div class="public-item">
        <div class="public-title">
          学校类别
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.schoolType}}
        </div>
      </div>
      <!-- 学校特色 -->
      <div class="public-item">
        <div class="public-title">
          学校特色
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.schoolFeature}}
        </div>
      </div>
      <!-- 主管部门 -->
      <div class="public-item">
        <div class="public-title">
          主管部门
        </div>
        <div class="public-text">
          {{orgInfo.company}}
        </div>
      </div>
      <!-- 所属企业 -->
      <div class="public-item">
        <div class="public-title">
          所属企业
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.affiliatedEnterprise}}
        </div>
      </div>
      <!-- 现任领导 -->
      <div class="public-item">
        <div class="public-title">
          现任领导
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.currentLeader}}
        </div>
      </div>
      <!-- 专职院士数 -->
      <div class="public-item">
        <div class="public-title">
          专职院士数
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.academician}}
        </div>
      </div>
      <!-- 高职专业 -->
      <div class="public-item">
        <div class="public-title">
          高职专业
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.higherVocationalProfession}}
        </div>
      </div>
      <!-- 本科专业 -->
      <div class="public-item">
        <div class="public-title">
          本科专业
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.undergraduateMajor}}
        </div>
      </div>
      <!-- 硕士点 -->
      <div class="public-item">
        <div class="public-title">
          硕士点
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.master}}
        </div>
      </div>
      <!-- 博士点 -->
      <div class="public-item">
        <div class="public-title">
          博士点
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.doctor}}
        </div>
      </div>
      <!-- 博士后 -->
      <div class="public-item">
        <div class="public-title">
          博士后
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.postdoctor}}
        </div>
      </div>
      <!-- 国家重点学科 -->
      <div class="public-item">
        <div class="public-title">
          国家重点学科
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.coreSubject}}
        </div>
      </div>
      <!-- 院系设置 -->
      <div class="public-item">
        <div class="public-title">
          院系设置
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.faculty}}
        </div>
      </div>
      <!-- 校训 -->
      <div class="public-item">
        <div class="public-title">
          校训
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.collegeMotto}}
        </div>
      </div>
      <!-- 校歌 -->
      <div class="public-item">
        <div class="public-title">
          校歌
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.schoolSong}}
        </div>
      </div>
      <!-- 院校代码 -->
      <div class="public-item">
        <div class="public-title">
          院校代码
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.schoolCode}}
        </div>
      </div>
      <!-- 知名校友 -->
      <div class="public-item">
        <div class="public-title">
          知名校友
        </div>
        <div class="public-text">
          {{orgInfo.orgAcademy.famousAlumni}}
        </div>
      </div>
      <!-- 机构概述 -->
      <div class="public-item">
        <div class="public-title">
          机构概述
        </div>
        <div class="public-text">
          <p>{{orgInfo.outline}}</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <!-- 机构学者 -->
      <div class="per-list"
           v-if="orgUser.length">
        <div class="title">机构学者</div>
        <ul>
          <li class="scholar"
              v-for="(item,index) in orgUser"
              :key="index"
              @click="jumpbaijia(item.id)">
            <van-image v-if="item.headPhoto"
                       width="65px"
                       round
                       height="65px"
                       fit="cover"
                       :src="$global.imgUrl + item.headPhoto" />
            <img v-else
                 style="width:65px;height:65px"
                 src="@/assets/img/login/4.png"
                 alt="">
            <div class="per-name">
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/views/mobileView/detail/components/Header.vue'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Top
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
      orgInfo: {
        orgAcademy: {
        }
      },
      orgUser: [],
      orgPeriodical: {}, // 主管/主办/出版期刊集合
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 跳转百家中间页
    jumpbaijia(id) {
      this.$router.push({
        path: '/jumpbaijia',
        query: {
          id: id
        }
      })
    },
    getInfo() {
      this.$apis.hundredServe.nfdetail({
        orgId: this.$route.query.orgId
      }).then((result) => {
        this.orgInfo = result.orgInfo
        this.orgUser = result.orgUser
        this.orgPeriodical = result.orgPeriodical
      }).catch((err) => {
        console.log(err)
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
}
</script>
<style lang='scss' scoped>
.all {
  background: #e5e5e5;
  margin-top: 70px;
  .top {
    overflow: hidden;
    padding: 0 16px 26px 16px;
    background-color: #fff;
    .logo {
      margin-top: 14px;
      display: flex;
      align-items: center;
      .left {
        margin-right: 10px;
      }
      .right {
        .title {
          font-size: 15px;
          font-family: PingFang;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
  .bottom {
    padding: 24px 16px 0 16px;
    margin-top: 8px;
    width: 100%;
    background: #fff;
    .per-list {
      .title {
        font-size: 18px;
        font-family: PingFang;
        font-weight: bold;
        color: #303030;
      }
      ul {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        padding: 20px 0;
        overflow-y: auto;
        li {
          width: 100px;
          margin-right: 16px;
          .per-name {
            text-align: center;
          }
        }
        .scholar {
          width: 65px;
          margin-right: 16px;
        }
      }
    }
  }
}
.public-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}
.public-item {
  margin-top: 20px;
}
.public-text {
  font-size: 15px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  span {
    margin-right: 10px;
  }
  .per-name {
    padding: 0 8px;
    display: inline-block;
    border: 1px dashed #4585f5;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #4459d3;
  }
}
::v-deep .van-image__img {
  vertical-align: middle;
}
</style>